import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading font-bold text-xl mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-background-50 text-primary-500 rounded-lg text-sm font-bold">
                蕉
              </span>
              香蕉漫画
            </Link>
            <p className="text-background-50/70 text-sm leading-relaxed">
              香蕉漫画精选热门韩漫、日漫、国漫分类推荐，涵盖恋爱、奇幻、热血等所有风格，为漫迷提供高清版漫画免费在线阅读和人气排行榜。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4 text-background-50">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">首页</Link>
              <Link to="/category/韩漫" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">韩漫推荐</Link>
              <Link to="/category/日漫" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">日漫推荐</Link>
              <Link to="/category/国漫" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">国漫推荐</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4 text-background-50">热门风格</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/韩漫?genre=恋爱" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">恋爱漫画</Link>
              <Link to="/category/日漫?genre=热血" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">热血漫画</Link>
              <Link to="/category/国漫?genre=古风" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">古风漫画</Link>
              <Link to="/category/韩漫?genre=奇幻" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">奇幻漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4 text-background-50">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">品牌介绍</Link>
              <Link to="/about" className="text-background-50/70 hover:text-background-50 text-sm transition-colors">联系我们</Link>
              <p className="text-background-50/50 text-sm mt-2">为漫迷提供最好的漫画推荐服务</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/50 text-sm">
            &copy; {currentYear} 香蕉漫画 BananaManga. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 hover:text-background-50 text-sm transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-50/50 hover:text-background-50 text-sm transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}